import { orderTestServiceCloud } from "@/services/orderTestRequest";

export function getAllNotes() {
  return orderTestServiceCloud({
    url: "/note/readNoteByCustomer",
    method: "get"
  })
}

export function updateNote(data) {
  return orderTestServiceCloud({
    url: "/note/updateNote",
    method: "put",
    data
  })
}

export function setNote(data) {
  return orderTestServiceCloud({
    url: "/note/createNote",
    method: "post",
    data
  })
}

export function deleteNoteById(data) {
  return orderTestServiceCloud({
    url: "/note//deleteNote",
    method: "delete",
    data
  })
}
